import { ruleRunner } from 'validations/ruleRunner';
import {
  isEmail,
  required,
  minLength,
  maxLength,
  arrayMinLength,
  arrayMaxLength,
  minimun,
  supportEmailNotEduzzUnlessUserIsEduzz
} from 'validations/rules';

const Validations = [
  ruleRunner('type', 'tipo', minimun(1)),
  ruleRunner('title', 'título', required, maxLength(255)),
  ruleRunner('description', 'descrição', required, minLength(100), maxLength(4000)),
  ruleRunner('image_id', 'imagem', required),
  ruleRunner('support_email', 'E-mail de suporte', isEmail, required, supportEmailNotEduzzUnlessUserIsEduzz),
  ruleRunner('categories', 'categorias', arrayMinLength(1), arrayMaxLength(5))
];

export default Validations;
